<template>
  <div class="intelligentAgriculture-page">
    <!-- 乡村资源一张图 -->
    <div class="haeder-container blackStatic" style="height:141px;">
      <Header></Header>
      <Nav></Nav>
    </div>
    	<div class="main text-img-box">
			<div class="top-banner">
                <h2 style="font-size: 52px;font-weight: 500;position: absolute;color: #fff; left: 15%;top: 381px;">乡村资源一张图</h2>
                <h2 style="font-size: 28px;font-weight: 500;position: absolute;color: #fff;left: 15%;top: 462px;">A picture of rural resources</h2>
                <img style="width:100%;height:auto" src="../../assets/img/caseDetails/village_resources/index.png">            
            </div>		

            <div class="village-resources-box">
                <i class="left-line"></i>
                <p style="color:#4ABC6A;font-size:20px;font-weight:700">乡村资源一张图</p>
                <i class="right-line"></i>
                <div class="village-resources-cbox">
                    <img src="../../assets/img/caseDetails/village_resources/img1.png">  
                    <h4>村民管理</h4>
                    <p>村组管理</p>  
                    <p>农户管理</p>  
                    <p>家庭成员</p>  
                    <p>家庭状况</p>  
                </div>
                <div class="village-resources-cbox">
                    <img src="../../assets/img/caseDetails/village_resources/img2.png">  
                    <h4>土地管理</h4>
                    <p>三类土地</p>  
                    <p>土地流转</p>  
                    <p>权证管理</p>  
                    <p>闲置情况</p>  
                </div>
                <div class="village-resources-cbox">
                    <img src="../../assets/img/caseDetails/village_resources/img3.png">  
                    <h4>资产管理</h4>
                    <p>产权管理</p>  
                    <p>资产租赁</p>  
                    <p>合同管理</p>  
                    <p>流转运营</p>  
                </div>
            </div>
			<!-- 模块4 -->
			<div class="maim-module-02">
				<div class="maim-module-02-center">
					<div class="maim-module-02-center-img">
						<img src="../../assets/img/caseDetails/village_resources/group1.png" class="img-model">
					</div>
					<div class="maim-module-02-center-text">
						<h2>乡村资源一张图</h2>
						<div class="segmentation">
							<img style="float:right;" src="../../assets/img/caseDetails/intelligentAgricultureall/index01-02.png">
						</div>
						<div class="text02">
							乡村数字化可视平台，通过地理信息，遥感测绘、人工智能等技术，打造涵盖乡村规划、乡村经营、乡村环境、乡村服务和乡村治理5个领域的“数字乡村一张图平台。
						</div>
					</div>
				</div>
			</div>
			<!-- 模块5 -->
			<div class="maim-module-03">
				<div class="maim-module-02-center">
					<div class="maim-module-02-center-text">
						<h2 style="text-align: left;">村民人口管理</h2>
						<div class="segmentation" style="text-align: left;">
							<img src="../../assets/img/caseDetails/intelligentAgricultureall/index01-02.png">
						</div>
						<div class="text02">
							村常住人口在线管理功能，一键查询户主及家庭成员情况，支持excel模版导入导出功能，方便录入及时更新，可视化显示村民各纬度构成情况，支持人口流入流出登记，支持特殊人群管理等功能。
						</div>
					</div>
					<div class="maim-module-02-center-img">
						<img src="../../assets/img/caseDetails/village_resources/group2.png" class="img-model">
					</div>
				</div>
			</div>
			<!-- 模块6 -->
			<div class="maim-module-02">
				<div class="maim-module-02-center">
					<div class="maim-module-02-center-img">
						<img src="../../assets/img/caseDetails/village_resources/group3.png" class="img-model">
					</div>
					<div class="maim-module-02-center-text">
						<h2>土地资源管理</h2>
						<div class="segmentation">
							<img style="float:right;" src="../../assets/img/caseDetails/intelligentAgricultureall/index01-02.png">
						</div>
						<div class="text02">
							土地资源流转管理，地块流转历史详情查询，村内土地流转动态趋势分析。
						</div>
					</div>
				</div>
			</div>
			<!-- 模块7 -->
			<div class="maim-module-03">
				<div class="maim-module-02-center">
					<div class="maim-module-02-center-text">
						<h2 style="text-align: left;">村集体资产管理</h2>
						<div class="segmentation" style="text-align: left;">
							<img src="../../assets/img/caseDetails/intelligentAgricultureall/index01-02.png">
						</div>
						<div class="text02">
							村集体资产管理，固定资产登记收录，货币资产及年度收支明细，股权分配管理，可视化大屏实时公示等功能。
						</div>
					</div>
					<div class="maim-module-02-center-img">
						<img src="../../assets/img/caseDetails/village_resources/group4.png" class="img-model">
					</div>
				</div>
			</div>
		</div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'  

export default {
  name: 'intelligentAgriculture',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {

    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style>
 .haeder-container {
	width: 100%;
	height: 129px;
	margin: 0 auto;
	background-color: #030512;
}

div:after,
li:after,
ul:after {
	clear: both;
	content: "";
	width: 0;
	height: 0;
	display: block;
	visibility: hidden;
}

*{
    margin:0;
    padding:0;
}
html, body, div, span, object, iframe,h1, h2, 
h3, h4, h5, h6, p, blockquote, pre,abbr, address, cite, code,del, dfn, 
em, img, ins,kbd, q, samp,small, strong, sub, sup, var,b, i,dl, dt, dd, 
ol, ul, li,fieldset, form, label, legend,table, caption, tbody, 
tfoot,thead,tr, th, td,article, aside, canvas, details, figcaption, 
figure, footer, header, hgroup, menu, nav, section, summary,time, mark, 
audio, video {
    margin:0;
    padding:0;
    border:0;
    outline:0;
    font-size:100%;
    vertical-align:baseline;
    background:transparent;
    outline-style:none;
}
 
body {
    line-height:1;
}
ol, ul{
    text-decoration: none;
    list-style: none;
}
a{
    margin:0;
    padding:0;
    border:0;
    font-size:100%;
    vertical-align:baseline;
    background:transparent;
    text-decoration:none;
    outline-style:none;
}
a:hover,a:focus{
    text-decoration:none;
    outline-style:none;
    }
table {
    border-collapse:collapse;
    border-spacing:0;
}
input, select {
    vertical-align:middle;
}
.clear{
    clear: both;
}








@media all and (max-width: 1400px) and (min-width: 820px) {
	.main-bunner-img2 {
		width: 100%;
		height: 600px !important;
		background-image: url(~@/assets/img/caseDetails/village_resources/index.png);
		background-repeat: no-repeat;
		background-size: contain;
	}
}
.main-bunner-img2 {
	width: 100%;
	height: 800px;
	background-image: url(~@/assets/img/caseDetails/village_resources/index.png);
	background-repeat: no-repeat;
	background-size: contain;
}

.maim-module-01 {
	width: 100%;
	height: 700px;
	background: rgba(255, 255, 255, 1);
	display: flex;
	align-items: center;
}

.maim-module-01-center {
	width: 1200px;
	margin: 0 auto;
}

.maim-module-01-center-text {
	width: 1200px;
	height: 180px;
	font-size: 20px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: rgba(51, 51, 51, 1);
	line-height: 36px;
}

.maim-module-02 {
	width: 100%;
	height: 700px;
	background: #FCF9FC;
	display: flex;
	align-items: center;
}

.maim-module-02-center {
	width: 1200px;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
}

.maim-module-02-center-img {
	width: 670px;
	height: 377px;
}

.maim-module-02-center-text {
	width: 460px;
	height: 377px;
	display: flex;
	flex-direction: column;

}

.text-img-box h2 {
	width: 460px;
	height: 45px;
	text-align: right;
	font-size: 32px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: rgba(48, 181, 94, 1);
	line-height: 45px;
	margin-top: 25px;
	margin-bottom: 15px;
}

.segmentation {
	width: 460px;
	height: 5px;
	text-align: right;
	margin-top: 5px;
	margin-bottom: 20px;
}

.text02 {
	width: 460px;
	height: 216px;
	font-size: 20px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: rgba(51, 51, 51, 1);
  line-height: 36px;
  text-align: left;
}

.maim-module-03 {
	width: 100%;
	height: 700px;
	background: #FFFEFF;
	display: flex;
	align-items: center;
}

.img-model {
	width: 670px;
	height: auto;
}

.bottom {
	width: 100%;
	height: 1114px;
	background-image: url(~@/assets/img/caseDetails/intelligentAgricultureall/bj.png);
	background-repeat: no-repeat;
	background-size: auto 100%;
}

.bottom-center {
	width: 1040px;
	margin: 0 auto;
}

h3 {
	width: 1040px;
	height: 45px;
	text-align: center;
	font-size: 32px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: rgba(51, 51, 51, 1);
	line-height: 45px;
	padding-top: 63px;
}

.separation-text {
	margin-top: 25px;
	display: flex;
	justify-content: center;
}

.separation-text-01 {
	width: 127px;
	height: 2px;
	text-align: center;
	background: rgba(51, 51, 51, 1);
	opacity: 0.49770000000000003;
}

.list {
	margin-top: 44px;
  text-align: left;
}

.list-text {
	display: inline-block;
	width: 848px;
	height: 36px;
	font-size: 20px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: rgba(51, 51, 51, 1);
	line-height: 36px;
  margin-left: 20px;
}
.village-resources-box{
    width: 1000px;
    margin: auto;
    padding: 80px 0;
    position: relative;
}
.village-resources-cbox{
    width: 27%;
    float: left;
    height: 360px;
    margin: 3%;
    background: #fff;
    box-shadow: 0 5px 2px #eaeaea;
    padding: 20px;
}
.village-resources-cbox img{
    width: 100px;
    margin: auto;
}
.village-resources-cbox h4{
    line-height: 58px;
	font-size: 18px;
}
.village-resources-cbox p{
    line-height: 40px;
    font-size: 16px;
} 
.left-line{
position: absolute;
    left: 50%;
    width: 60px;
    height: 1px;
    background: #C7C7C7;
    margin-left: 80px;
    top: 89px;
}

.right-line{
position: absolute;
    right: 50%;
    width: 60px;
    height: 1px;
    background: #C7C7C7;
    margin-right: 80px;
    top: 89px;
}




</style>